<svg
  xmlns="http://www.w3.org/2000/svg"
  class="icon icon-tabler icon-tabler-disabled"
  [attr.width]="size"
  [attr.height]="size"
  [attr.viewBox]="'0 0 '+ size + ' ' + size"
  [attr.stroke-width]="strokeWidth"
  stroke="currentColor"
  fill="none"
  stroke-linecap="round"
  stroke-linejoin="round"
  style="display: flex;align-items: center;justify-content: center;">
  <use [attr.xlink:href]="'assets/icons/tabler-sprite.svg#tabler-' + icon"/>
</svg>
